import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Cons from '../../isomorphic/cons';
import PermissionHelper from '../components/permission-wrapper';

@inject('appStore')
@observer
export default class MainTabs extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <ul className="nav nav-tabs bundle-tab nav-tabs-fillup" role="tablist" data-init-reponsive-tabs="collapse">
                <PermissionHelper permission="dashboard.view">
                    <li className={appStore.viewStore.selectedTab === Cons.pages.dashBoard ? 'active' : ''}>
                        <a
                            href="/skytc/dashboard"
                            onClick={(e) => {
                                e.preventDefault();
                                appStore.viewStore.openDashBoardPage();
                                return false;
                            }}
                        >
                            Dashboard
                        </a>
                    </li>
                </PermissionHelper>
                <PermissionHelper permission="files.view">
                    <li className={appStore.viewStore.selectedTab === Cons.pages.files ? 'active' : ''}>
                        <a
                            href="/skytc/files"
                            onClick={(e) => {
                                e.preventDefault();
                                appStore.viewStore.openFilesPage();
                                return false;
                            }}
                        >
                            Files
                        </a>
                    </li>
                </PermissionHelper>
                <PermissionHelper permission="reports.view">
                    <li className={appStore.viewStore.selectedTab === Cons.pages.reports ? 'active' : ''}>
                        <a
                            href="/skytc/reports"
                            onClick={(e) => {
                                e.preventDefault();
                                appStore.viewStore.openReportsPage();
                                return false;
                            }}
                        >
                            Reports
                        </a>
                    </li>
                </PermissionHelper>
                <PermissionHelper permission="coordinators.view">
                    <li className={appStore.viewStore.selectedTab === Cons.pages.coordinators ? 'active' : ''}>
                        <a
                            href="/skytc/coordinators"
                            onClick={(e) => {
                                e.preventDefault();
                                appStore.viewStore.openCoordinatorsPage();
                                return false;
                            }}
                        >
                            TCs
                        </a>
                    </li>
                </PermissionHelper>
                <PermissionHelper permission="agents.view">
                    <li className={appStore.viewStore.selectedTab === Cons.pages.agents ? 'active' : ''}>
                        <a
                            href="/skytc/agents"
                            onClick={(e) => {
                                e.preventDefault();
                                appStore.viewStore.openAgentsPage();
                                return false;
                            }}
                        >
                            Agents
                        </a>
                    </li>
                </PermissionHelper>
                <PermissionHelper permission="sales/agents.view">
                    <li className={appStore.viewStore.selectedTab === Cons.pages.salesAgents ? 'active' : ''}>
                        <a
                            href="/skytc/sales"
                            onClick={(e) => {
                                e.preventDefault();
                                appStore.viewStore.openSalesPage();
                                return false;
                            }}
                        >
                            Agents
                        </a>
                    </li>
                </PermissionHelper>
                <PermissionHelper permission="emailtemplates.view">
                    <li className={appStore.viewStore.selectedTab === Cons.pages.emailTemplates ? 'active' : ''}>
                        <a
                            href="/skytc/emailtemplates"
                            onClick={(e) => {
                                e.preventDefault();
                                appStore.viewStore.openEmailTemplatesPage();
                                return false;
                            }}
                        >
                            Email Templates
                        </a>
                    </li>
                </PermissionHelper>
            </ul>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app-main/main-tabs.js